import validate from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@22.5.4_eslint@8.57.0_rollup@4.21.2_stylelint@16.9.0_typescript@5.6.2_vite@5.4.4/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/app/middleware/01.auth.global.ts";
import _02_45locales_45global from "/app/middleware/02.locales.global.ts";
import analytics_45global from "/app/middleware/analytics.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@22.5.4_eslint@8.57.0_rollup@4.21.2_stylelint@16.9.0_typescript@5.6.2_vite@5.4.4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45locales_45global,
  analytics_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}